import React from 'react'
import { iconMap } from '../utils/icons'

export default function ProductCard({ product }) {
  const { icon, title, description, href, isNew, comingSoon } = product
  const IconSvg = iconMap[icon] ?? iconMap['layout-grid']

  const cardClass = ['card', comingSoon ? 'card-disabled' : ''].filter(Boolean).join(' ')

  const inner = (
    <>
      <span className="card-icon" aria-hidden="true">
        <IconSvg />
      </span>
      <span className="card-title">
        {title}
        {isNew && <span className="badge-new">novo</span>}
      </span>
      <span className="card-desc">{description}</span>
      {comingSoon && <span className="badge-coming">Em breve</span>}
      {!comingSoon && href && (
        <span className="card-arrow" aria-hidden="true">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="7" y1="17" x2="17" y2="7" /><polyline points="7 7 17 7 17 17" />
          </svg>
        </span>
      )}
    </>
  )

  if (comingSoon || !href) {
    return <div className={cardClass}>{inner}</div>
  }

  return (
    <a href={href} target="_blank" rel="noopener noreferrer" className={cardClass}>
      {inner}
    </a>
  )
}
